module.exports = __webpack_public_path__ + "static/media/icon-mountain.93af2bca.svg";